export const baseURL = "https://careers-api.aynnaka.ma/api";
export const baseURLFile = "https://careers-api.aynnaka.ma";

//
// export const baseURL = "http://192.168.100.165:8000/api";
// export const baseURLFile = "http://192.168.100.165:8000";
